import { isInstantBookingLEHotelItem } from 'lib/checkout/checkoutUtils'
import { getJourneyV2IdKey } from 'lib/flights/flightUtils'
import { last } from 'lib/array/arrayUtils'

interface BundledDates {
  hotelCheckIn?: string
  hotelCheckOut?: string
  flightDepartureDate?: string
  flightReturnDate?: string
}

interface GetBundledDatesParams {
  isBundled: boolean
  startDate?: string
  endDate?: string
  itemViews: Array<{ item: App.Checkout.AnyItem }>
  flightItems: Array<App.Checkout.FlightItem>
  journeysById: Record<string, App.AnyJourney>
}

export function getBundledDates(params: GetBundledDatesParams): BundledDates {
  const { isBundled, startDate, endDate, itemViews, flightItems, journeysById } = params

  if (!isBundled) {
    return {
      hotelCheckIn: startDate,
      hotelCheckOut: endDate,
      flightDepartureDate: undefined,
      flightReturnDate: undefined,
    }
  }

  // Find the accommodation item ID
  const accommodationItemId = itemViews[0]?.item?.itemId
  if (!accommodationItemId) {
    return {
      hotelCheckIn: undefined,
      hotelCheckOut: undefined,
      flightDepartureDate: undefined,
      flightReturnDate: undefined,
    }
  }

  // Find the flight item that bundles with this accommodation item
  const bundledFlightItem = flightItems.find((flightItem: App.Checkout.FlightItem) =>
    flightItem.bundledItemIds?.includes(accommodationItemId)
  )

  // Get hotel dates from accommodation item
  const accommodationItem = itemViews[0]?.item
  const hotelCheckIn = isInstantBookingLEHotelItem(accommodationItem) ? accommodationItem.checkIn : undefined
  const hotelCheckOut = isInstantBookingLEHotelItem(accommodationItem) ? accommodationItem.checkOut : undefined

  // Get flight dates from flight item
  const departureFlight = bundledFlightItem?.flights?.[0]
  const flightDepartureDate = departureFlight?.departingDate

  // Get return flight arrival date (when flight arrives back at origin)
  const returnFlight = bundledFlightItem?.flights?.[1]
  let flightReturnDate: string | undefined
  if (returnFlight?.journeyId && bundledFlightItem?.searchId) {
    const journeyKey = getJourneyV2IdKey(returnFlight.journeyId, bundledFlightItem.searchId, returnFlight.fareFamily?.id)
    const returnJourney = journeysById[journeyKey] as App.JourneyV2 | undefined
    const returnFlightSegments = returnJourney?.flightGroup?.flights
    const lastReturnSegment = returnFlightSegments && returnFlightSegments.length > 0
      ? last(returnFlightSegments)
      : undefined
    flightReturnDate = lastReturnSegment?.arrivalDate
  }

  return {
    hotelCheckIn,
    hotelCheckOut,
    flightDepartureDate,
    flightReturnDate,
  }
}
